module.exports = __webpack_public_path__ + "img/BlinkArt_Staff_Epic.3e6ddb99.png";